<template>
  <span class="ml-2" :style="color">{{ time }}</span>
</template>   
<script>
import moment from "moment-timezone";
export default {
  name: "relogio",
  data: () => ({
    intervalId: 0,
    time: "00:00:00",
  }),
  props: {
    datainicial: { type: Date },
    interval: { type: Number, default: 1000 },
    color: { type: String, default: "#000" },
  },
  mounted() {
    this.intervalId = setInterval(this.updateTimer, this.interval);
  },
  methods: {
    tempo() {
      var currentTime = new Date(),
        timeElapsed = new Date(currentTime - this.datainicial),
        hour = timeElapsed.getUTCHours(),
        min = timeElapsed.getUTCMinutes(),
        sec = timeElapsed.getUTCSeconds();

      this.time =
        this.padTime(hour) + ":" + this.padTime(min) + ":" + this.padTime(sec);
    },
    updateTimer() {
      let future = this.datainicial;
      let now = new Date();
      let diff = now - future;

      let days = Math.floor(diff / (1000 * 60 * 60 * 24));
      let hours = Math.floor(diff / (1000 * 60 * 60));
      let mins = Math.floor(diff / (1000 * 60));
      let secs = Math.floor(diff / 1000);

      let d = days;
      let h = hours - days * 24;
      let m = mins - hours * 60;
      let s = secs - mins * 60;
      if (h < 10) h = `0${h}`;
      if (m < 10) m = `0${m}`;
      if (s < 10) s = `0${s}`;
      if (d > 0) this.time = `${d} dias `;
      this.time = d > 0 ? `${d} dias ${h}:${m}:${s}` : `${h}:${m}:${s}`;
    },
    padTime(time) {
      return (time < 10 ? "0" : "") + time;
    },
    getDate() {
      console.log(`HORARIO`, this.datainicial);
      return moment(this.datainicial).startOf("hour").fromNow();
    },
  },

  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>